import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { startCase } from 'lodash';

class TypeRenderer extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { value, data } = this.props;
    if (!data || !value || value.length === 0) {
      return null;
    }
    const types = value;
    return (
      <div>
        {types.map(t => (
          <span key={t}><span className="label label-default">{startCase(t)}</span> </span>
        ))}
      </div>
    );
  }
}

TypeRenderer.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }),
};
TypeRenderer.defaultProps = {
  value: null,
  data: null,
};


export default TypeRenderer;
